import { DEFAULT_SYNTAX } from '../languages';
export default function getSyntax(node) {
  return node.getIn(['data', 'language']) || DEFAULT_SYNTAX;
}